import BaseModelAPI from '../BaseModelAPI';

export default class VwPartGoodReceiptDetail extends BaseModelAPI {
    static entity = 'vwpartgoodreceiptdetail';
    static entityName = 'partgoodreceiptdetail';

    constructor() {

        /*APP_MODEL_DEFINITION*/
        this.partGoodReceiptId = '';
        this.partId = '';
        this.partNumber = '';
        this.partName = '';
        /*END_APP_MODEL_DEFINITION*/
    }

    static async getListVw(this_, filter, sorting, pageIndex, pageSize, persistBy) {
        let filterArray = Array();
        if (filter != null && filter != undefined) {
            // console.log(filter);
            filterArray = this.getFilter(filter);
        }
        if (sorting != null && sorting != undefined) {
            Object.entries(sorting).map(([key, value]) => {
                if (key != '') {
                    filterArray.push("sorting[" + key + "]=" + (value ? "1" : "0"));     // draftFromUpload & draftMode
                }
            });

        }
        if (pageIndex != null) {
            filterArray.push("pageIndex=" + pageIndex);
        }
        if (pageSize != null) {
            filterArray.push("pageSize=" + pageSize);
        }
        let params = "";
        if (filterArray.length > 0) {
            params = "?" + filterArray.join("&");
        }

        //DEBUG

        return this_.$http.get(`${this.entityName}/vwpartgoodreceiptdetails` + params)
            .then(response => {
                if (response != null) {
                    return response.data;
                }
                return response;
            })
            .catch(function (error) {
                this_.$store.dispatch('addErrorMessageGlobal', error);
                throw error;
            });
    }

}